var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.32809 15.6719C5.92184 17.2344 7.81247 18.0156 9.99997 18.0156C12.1875 18.0156 14.0625 17.2344 15.625 15.6719C17.2187 14.0781 18.0156 12.1875 18.0156 10C18.0156 7.8125 17.2187 5.9375 15.625 4.375C14.0625 2.78125 12.1875 1.98438 9.99997 1.98438C7.81247 1.98438 5.92184 2.78125 4.32809 4.375C2.76559 5.9375 1.98434 7.8125 1.98434 10C1.98434 12.1875 2.76559 14.0781 4.32809 15.6719ZM2.92184 2.96875C4.89059 1 7.24997 0.015625 9.99997 0.015625C12.75 0.015625 15.0937 1 17.0312 2.96875C19 4.90625 19.9843 7.25 19.9843 10C19.9843 12.75 19 15.1094 17.0312 17.0781C15.0937 19.0156 12.75 19.9844 9.99997 19.9844C7.24997 19.9844 4.89059 19.0156 2.92184 17.0781C0.984344 15.1094 0.0155945 12.75 0.0155945 10C0.0155945 7.25 0.984344 4.90625 2.92184 2.96875ZM9.01559 4.98438H10.9843V10.9844H9.01559V4.98438ZM9.01559 13H10.9843V15.0156H9.01559V13Z",
    fill: "#E74C3C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.95a90951.svg";
export { ForwardRef as ReactComponent };